import React, { useEffect } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import usePathBasedPageTracking from 'tools/hooks/usePathBasedPageTracking';
import useScrollToTop from 'tools/hooks/useScrollToTop';
import { pathOfFirstStepOfFlow } from './index';
import { obFlowRoutes } from './onboardingFlow';
import { publicRoutes } from './public';

const Routes = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      navigate({ pathname: pathOfFirstStepOfFlow }, { replace: true });
    }
  }, [location, navigate]);

  usePathBasedPageTracking();
  useScrollToTop();

  const element = useRoutes([...publicRoutes, ...obFlowRoutes]);

  return (
    <>{element}</>
    //   {/* TODO: Add 404 Route:
    //       <Route><NotFoundPage /><Route>
    //     */}
    // </RouterRoutes>
  );
};

export default Routes;
